<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NRkqJt/tc-custom/9781480493247.jpg?1702083668573" alt="This image is the cover for the book No Flame But Mine, The Lionwolf Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Flame But Mine, The Lionwolf Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The Lionwolf scrolls conclude in this epic fantasy adventure set in a snowbound world where redemption and revenge collide</b><br/><br/> The powerful mage Thryfe gropes through the steel-white snows that have covered the huddles of ruins, abandoned villages, and casualties of the White Death. He is searching for the stunning witch Jemhara, but his magic mirror can only see her past, not her present, and the sorcerer fears that a mad force abroad on the ice-locked earth is keeping them apart. At last, he finds Jemhara in the rebuilt town of Kandexa. Their impassioned and bizarre love rekindles, resulting in the birth of a boy with red hair, blue eyes, and golden skin: He is Lionwolf reborn from the land of the dead.<br/>  <br/> But the vicious dark lord Zzth has been burning under the sea, waiting for the moment of his inevitable return, planning for mutilation, destruction, and frigid ruin.<br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tanith Lee
      </h2>
      
      <p class="authorDescription body article">Tanith Lee (1947&ndash;2015) was born in the United Kingdom. Although she couldn&rsquo;t read until she was eight, she began writing at nine and never stopped, producing more than ninety novels and three hundred short stories. She also wrote for the BBC television series <I>Blake&rsquo;s 7</I> and various BBC radio plays. After winning the 1980 British Fantasy Award for her novel<I> Death&rsquo;s Master</I>, endless awards followed. She was named a World Horror Grand Master in 2009 and honored with the World Fantasy Award for Life Achievement in 2013. Lee was married to artist and writer John Kaiine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48c331be